/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTguNDMgN0gxNC44NlY4SDguNDNINy40M0gxVjdINy40M0g4LjQzWiIgZmlsbD0iaW5oZXJpdCIvPg==";